import styled from 'styled-components';
import { testableStyledComponentConfig } from '@24i/nxg-sdk-gluons';
import { Icon } from '../../../../../../Icons';
export const Container = styled.li `
    display: flex;
    flex-direction: row;
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.12px;
    align-items: center;
    margin: 16px;
    cursor: pointer;
`;
export const Name = styled.div.withConfig(testableStyledComponentConfig) `
    display: flex;
    flex: 1;
    color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textPrimary) || 'white'; }};
`;
export const Current = styled.div `
    color: ${({ theme }) => { var _a; return ((_a = theme === null || theme === void 0 ? void 0 : theme.color) === null || _a === void 0 ? void 0 : _a.textPrimary) || 'white'; }};
    opacity: 0.6;
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
`;
export const StyledIcon = styled(Icon) `
    width: 24px;
    height: 24px;
    margin-left: 5px;
`;
//# sourceMappingURL=index.js.map